import { all, call, fork } from 'redux-saga/effects';
import authorization from './authorization/authorization';
import watchAndLog from './errors/errors';
import dashboard from './dashboard/dashboard';

export default function* rootSaga() {
  yield all([call(authorization), fork(watchAndLog), call(dashboard)]);
}
